import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ConfirmationModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  closeIcon
}) {
  return (
    <Modal backdrop="static" keyboard={false} isOpen={isOpen} toggle={onCancel}>
      <ModalHeader
        toggle={onCancel}
        close={
          <FontAwesomeIcon
            color="black"
            icon="times"
            size="2x"
            onClick={onCancel}
          />
        }
      >
        {title}
      </ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button color="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;